// import-dialog-data.token.ts
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ImportDialogData {
  title?: string;
  acceptLabel?: string;
  cancelLabel?: string;
  fileTypes?: string;
  endpoint?: string;
  fieldName?: string;
  skipBackendEnrichment?: boolean;
  importMethod?: (file: File) => Observable<any>; // ← Nuevo campo
}

export const IMPORT_DIALOG_DATA = new InjectionToken<ImportDialogData>('IMPORT_DIALOG_DATA');
